import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16adede6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row pt-5" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = {
  key: 0,
  class: "card p-5"
}
const _hoisted_4 = { class: "d-flex flex-row justify-content-between align-items-center pb-3" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-column flex-md-row p-2 gap-3"
}
const _hoisted_6 = {
  class: "row gap-4",
  style: {"color":"#464E5F"}
}
const _hoisted_7 = {
  class: "card p-5 rounded d-flex justify-content-between flex-column card-grafico",
  style: {"border":"1px solid #b5b5c3","color":"#464E5F"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#464E5F","font-size":"20px"} }, "Média de dias em cada etapa", -1))
const _hoisted_9 = {
  key: 1,
  width: "220",
  height: "220",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  d: "M19.4041 11.1765H10.6802L16.4902 16.9864C16.7122 17.2085 17.0777 17.2265 17.306 17.0114C18.7288 15.671 19.7074 13.864 19.9946 11.8327C20.0438 11.4849 19.7552 11.1765 19.4041 11.1765ZM18.8221 8.79412C18.5192 4.40221 15.0096 0.892649 10.6177 0.589708C10.2824 0.566547 10.0001 0.849267 10.0001 1.1853V9.41177H18.2269C18.5629 9.41177 18.8453 9.12941 18.8221 8.79412ZM8.23537 11.1765V2.45258C8.23537 2.10147 7.92692 1.81287 7.57949 1.86213C3.19824 2.48125 -0.150655 6.30883 0.00522741 10.896C0.165522 15.607 4.22177 19.4702 8.93501 19.411C10.7879 19.3879 12.5001 18.7908 13.9078 17.7923C14.1982 17.5864 14.2174 17.1588 13.9655 16.907L8.23537 11.1765Z",
  fill: "gray"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "d-flex justify-content-between gap-1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total de lojas:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dotted" }, null, -1))
const _hoisted_15 = { class: "fw-bold" }
const _hoisted_16 = { class: "d-flex justify-content-between gap-1" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tempo médio geral:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dotted" }, null, -1))
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = {
  key: 1,
  class: "row col-md-9 gap-6"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"text-align":"center","font-size":"22px"},
  class: "m-0 texto cor_texto_1"
}, "Nenhum SLA encontrado . . .", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "card p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_CardStatusImplantacao = _resolveComponent("CardStatusImplantacao")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loadingSla)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Title, { description: "No período selecionado" }, {
                default: _withCtx(() => [
                  _createTextVNode("Status das Implantações: " + _toDisplayString(_ctx.slaImplantacao ? _ctx.slaImplantacao.total :
        ''), 1)
                ]),
                _: 1
              })
            ]),
            (_ctx.slaImplantacao)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_CardStatusImplantacao, {
                      title: "Cadastro do cliente no APP Indicar",
                      sla: _ctx.slaImplantacao.cadastroApp,
                      dotColor: "#3699FF",
                      iconName: "store-alt"
                    }, null, 8, ["sla"]),
                    _createVNode(_component_CardStatusImplantacao, {
                      title: "Aguardando base de produtos da automação",
                      sla: _ctx.slaImplantacao.slaWaitingProducts,
                      dotColor: "#FFB822",
                      iconName: "database"
                    }, null, 8, ["sla"]),
                    _createVNode(_component_CardStatusImplantacao, {
                      title: "Aguardando chegada do tablet",
                      sla: _ctx.slaImplantacao.slaWaitingTablet,
                      dotColor: "#F64E60",
                      iconName: "tablet-alt"
                    }, null, 8, ["sla"]),
                    _createVNode(_component_CardStatusImplantacao, {
                      title: "Preparando setup",
                      sla: _ctx.slaImplantacao.setup,
                      dotColor: "#203972",
                      iconName: "cog"
                    }, null, 8, ["sla"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    (_ctx.slaImplantacao.totalLojas > 0)
                      ? (_openBlock(), _createBlock(_component_apexchart, {
                          key: 0,
                          type: "donut",
                          options: _ctx.chartOptions,
                          series: _ctx.series
                        }, null, 8, ["options", "series"]))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11)),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.slaImplantacao? _ctx.slaImplantacao.totalLojas: '0'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.slaImplantacao? _ctx.slaGeral: '0') + " dias", 1)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createVNode(_component_el_skeleton, {
              animated: "",
              rows: 1
            })
          ]))
    ])
  ]))
}